

export const ToastType = {
    Warn: 'warn',
    Success: 'success',
    Info: 'info',
    Error: 'error',
};


export const ActionType = {
    InitialDataFetch: 'INITIAL_DATA_FETCH',
    ToggleNav: 'TOGGLE_NAV',
    ChangeFilter: 'CHANGE_FILTER',
    ClearFilter: 'CLEAR_FILTER',
    SetWishList: 'SET_WISHLIST',
    SetCartList: 'SET_CARTLIST',
    SetCartPriceDetails: 'SET_CART_PRICE_DETAILS',
    ResetCartPriceDetails: 'RESET_CART_PRICE_DETAILS',
    ClearCart: 'CLEAR_CART',
    AddAddress: 'ADD_ADDRESS',
    EditAddress: 'EDIT_ADDRESS',
    DeleteAddress: 'DELETE_ADDRESS',
    ADD_ORDER: 'ADD_ORDER',
};